export default {
  // Action & Navigation
  close: 'Bezárás',
  back: 'Vissza',
  okay: 'Oké',
  go: 'Mehet',
  save: 'Mentés',
  cancel: 'Mégsem',
  update: 'Frissítés',
  create: 'Létrehozás',
  edit: 'Szerkesztés',
  add: 'Hozzáadás',
  factorAdd: 'Hiányzó faktor kiválasztása',
  delete: 'Törlés',
  search: 'Keresés',
  print: 'Nyomtatás',
  eventPrint: 'Páciens esemény nyomtatás',
  yes: 'Igen',
  no: 'Nem',
  have: 'Van',
  reset: 'Visszaállítás',
  next: 'Tovább',
  doesntHave: 'Nincs',
  saveChanges: 'Változások mentése',
  multiselectHint: "Mit szeretne a kiválasztott elemekkel?",
  deselectAll: "Kijelölések törlése",
  details: "Részletek",
  chooseTimeframe: "Válassza ki az idősávot",
  exportFormat: "Export formátum",
  exportFields: "Exportálandó adatok",
  export: "Exportálás",

  // Errors
  notFound: 'Ez az elem nem található.',
  notFoundForPrimaryManager: 'Kérjük ellenőrizze, hogy megfelelő centrumot választott-e ki, mert ebből a centrumból más centrum adataihoz nem férhet hozzá.',
  unknownErrorOccurred: 'Ismeretlen hiba történt!',
  unknownErrorOccurredCheckForm: 'Ismeretlen hiba történt, ellenőrizze az űrlapot!',
  unknown: 'Ismeretlen',

  // Generic fields
  status: 'Állapot',
  statuses: 'Állapotok',
  dateFrom: 'Kezdet',
  dateUntil: 'Vég',
  searchText: 'Keresendő kifejezés',
  detailedSearch: 'Részletes kereső',
  patient: 'Páciens',
  doctor: 'Orvos',
  drug: 'Gyógyszer',
  center: 'Centrum',
  chiefDoctor: 'Főorvos',
  developer: 'Fejlesztő',

  titles: {
    settings: "Beállítások",
    profile: "Profil",
    dashboard: "Vezérlőpult",
    centers: "Centrumok",
    doctors: "Orvosok",
    events: "Események",
    eventStat: "Esemény statisztikák",
    eventExport: "Esemény exportálás",
    patients: "Páciensek",
    patientProfile: "Pácient profil",
    editPatient: "Páciens szerkesztése",
    createPatient: "Páciens hozzáadása",
    drugs: "Gyógyszerek",
    stocks: "Készletek",
    statistics: "Statisztika",
    eventTypeFilters: "Válassza ki a listázandó eseményeket",
  },

  address: {
    label: "Cím",
    country: "Ország",
    postalCode: "Irányítószám",
    state: "Megye",
    city: "Város",
    line1: "Cím sor 1",
    line2: "Cím sor 2",
    line3: "Cím sor 3"
  },

  dateRange: {
    selectWindow: "Gyors időablak választás",
    windowOptions: {
      last30Day: 'Utolsó 30 nap',
      lastMonth: 'Előző hónap',
      last90days: 'Utolsó 90 nap',
      lastQuarter: 'Előző negyedév'
    },
  },

  seedDummyData: "Fejlesztési adatok létrehozása (páciensek, készletek, események)",
};
